var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { Stack, Step, StepLabel, Stepper, styled, Typography, } from "@mui/material";
import { Colors } from "../util/theme";
var QontoStepIconRoot = styled("div")(function (_a) {
    var ownerState = _a.ownerState;
    return (__assign(__assign({ color: "#eaeaf0", display: "flex", height: 22, alignItems: "center" }, (ownerState.active && {
        color: "#0048B6",
    })), { "& .QontoStepIcon-completedIcon": {
            color: "#0048B6",
            zIndex: 1,
            fontSize: 18,
        }, "& .QontoStepIcon-circle": {
            width: 16,
            height: 16,
            borderRadius: "50%",
            backgroundColor: "currentColor",
        } }));
});
var QontoStepIcon = function (props) {
    var active = props.active, completed = props.completed;
    return (_jsx(QontoStepIconRoot, __assign({ ownerState: { active: active } }, { children: completed ? (_jsx(CheckCircleIcon, { color: "success" })) : !completed && !active ? (_jsx(CircleIcon, {})) : (_jsx(CircleIcon, { sx: { color: Colors.AZUL_GOV } })) })));
};
export var ProgressStepper = function (_a) {
    var steps = _a.steps;
    var stepAtivo = steps.findIndex(function (step) { return step.etapaAtual; });
    var activeStepRef = useRef(null);
    useEffect(function () {
        if (activeStepRef.current) {
            activeStepRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center",
            });
        }
    }, [stepAtivo]);
    return (_jsx(Stack, __assign({ marginY: "1.5rem" }, { children: _jsx("div", __assign({ style: { overflowX: "auto" } }, { children: _jsx(Stepper, __assign({ activeStep: stepAtivo, sx: { display: "flex", alignItems: "start", gap: "2rem" } }, { children: steps.map(function (step, index) { return (_jsxs(Step, __assign({ completed: index < stepAtivo, sx: { minWidth: "10rem" }, ref: index === stepAtivo ? activeStepRef : null }, { children: [_jsx(StepLabel, __assign({ StepIconComponent: QontoStepIcon }, { children: _jsx(Typography, __assign({ fontWeight: "600", fontSize: "0.8rem", noWrap: true }, { children: step.descricao })) })), index > stepAtivo ? (_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem", mt: "0.5rem" }, { children: "Pendente" }))) : (_jsxs("div", { children: [(step === null || step === void 0 ? void 0 : step.dataResultado) && (_jsxs(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem", my: "0.5rem", flexWrap: "wrap" }, { children: [new Date(step.dataResultado).toLocaleString("pt-BR", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        }), "h"] }))), _jsx(Typography, __assign({ my: "0.5rem", color: "textSecondary", flexWrap: "wrap" }, { children: step.descricaoResultado }))] }))] }), step.ordem)); }) })) })) })));
};
